import styled, { keyframes } from "styled-components";
import { theme } from "../../constants/StyledComponents";

const fadeInSlideDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const StyledSelectTimespan = styled.div`
  width: 100%;
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

export const SelectTimespanBox = styled.div`
  position: absolute;
  box-sizing: border-box;
  width: 100%;
  border: 1px solid ${theme.colors.black};
  border-radius: ${theme.variables.border_radius_1};
  background-color: ${theme.colors.white};
  z-index: 1000;
  margin-top: 2px;
  animation: ${fadeInSlideDown} 0.1s ease-out;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  padding: 12px;
  gap: 12px;
`;

export const TimespanSelect = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  padding: 0px 0px;
  gap: 3px;
`;

export const TimespanItem = styled.div<{
  $selected?: boolean;
}>`
  background-color: ${({ $selected }) =>
    $selected ? theme.colors.purple : "transparent"};
  &:hover {
    background-color: ${({ $selected }) =>
      $selected ? theme.colors.purple : theme.colors.purple_2};
  }
  box-sizing: border-box;
  width: 100%;
  padding: 4px 8px;
  border-radius: ${theme.variables.border_radius_1};
`;

export const StyledCounterItem = styled.div`
  width: 60px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 0px 0px;
  gap: 20px;
  cursor: auto;
`;
